import AppChrome from '../../../components/AppChrome'
import HeroIllustration from '../../../components/HeroIllustration'
import PageSegments from '../../../components/pageSegments/PageSegments'

export { getServerSideProps } from '../../../graphql/onePage'

function OnePage( { entry: onePage } ) {
  return (
    <div>
      <AppChrome>
        <HeroIllustration 
          title={ onePage.mainTitle }
          subtitle={ onePage.subtitle }
          illustration="brixel-hero-house-full-scene-2"
          buttonLabel={ onePage.buttonLabel }
          buttonLink={ onePage.buttonLink }
          partnerLabel={ onePage.partnerLabel }
          partnerLogos={ onePage.logos }
        />
        <PageSegments pageSegments={ onePage.pageSegments } />
      </AppChrome>
    </div>
  )
}

export default OnePage
